import type { Maybe } from '@adornis/base/utilTypes.js';
import { getByID } from '@adornis/baseql/operations/mongo.js';
import type { BaseQLSelectionSet } from '@adornis/baseql/utils/queryGeneration.js';
import { css } from '@adornis/chemistry/directives/css.js';
import { ChancenComponentSemanticEntityMultiPicker } from '@chancenwerk/client/components/semantics/chancen-component-semantic-entity-multi-picker.js';
import { KpfFilter } from '@chancenwerk/db/filter/KpfFilter.js';
import { KPFAPI } from '@chancenwerk/master-data-management/kpf/api/KPFAPI.js';
import { KPF } from '@chancenwerk/master-data-management/kpf/entities/KPF.js';
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
/**
 * @element chancen-component-semantic-kpf-multi-picker
 */
@customElement('chancen-component-semantic-kpf-multi-picker')
export class ChancenComponentSemanticKpfPicker extends ChancenComponentSemanticEntityMultiPicker<KPF, KpfFilter> {
  override placeholder: string = 'KPF';

  constructor() {
    super();
    this.renderString = (v: Maybe<KPF>) => (v ? v.kuerzel : '');
    this.renderItem = (v: KPF) => html`
      <cr-flex ${css({ padding: `${this.spacing.sm} ${this.spacing.md}` })}>
        <cr-checkbox
          disabled
          boolean-only
          .value=${this.value.value?.includes(v)}
          label=${v ? v?.toString() : ''}
        ></cr-checkbox>
      </cr-flex>
    `;
  }

  protected override _subscription() {
    return KPFAPI.subscribeByFilter;
  }

  protected override _resolveID(ids: string[]): (gqlFields: BaseQLSelectionSet<KPF>) => Promise<Maybe<KPF[]>> {
    return getByID<typeof KPF>(KPF, ids);
  }

  protected override _filter() {
    return KpfFilter;
  }

  protected override _selectionSet() {
    return {
      kuerzel: 1,
      schoolID: 1,
      school: {
        name: 1,
        kuerzel: 1,
      },
      produkt: {
        name: 1,
        kuerzel: 1,
      },
      standardMembershipFee: 1,
    };
  }
}
